import React, {useState} from 'react';
import { Box, ThemeProvider, Tabs, Tab, AppBar } from '@material-ui/core';
import theme from 'themes/mui-theme';
import TableScene from 'scenes/table';
import GraphScene from 'scenes/graph';
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import cs from "date-fns/locale/cs";
import useClasses from './index.style';
import {ReactQueryConfigProvider} from 'react-query';

const TABLE_TAB_KEY = "TABLE";
const GRAPH_TAB_KEY = "GRAPH";

const Root:React.FC = () => {
    const classes = useClasses();
    const [ tab, setTab ] = useState(TABLE_TAB_KEY);

    return (
        // <Provider store={store}>
            <ThemeProvider theme={theme}>
                <ReactQueryConfigProvider config={{ queries: { refetchOnWindowFocus: false } }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={cs}>
                    <Box className={classes.root}>
                        <AppBar position="static" color="default">
                            <Tabs
                                value={tab}
                                onChange={(_, value) => setTab(value)}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="fullWidth"
                            >
                                <Tab value={TABLE_TAB_KEY} label="Tabulka"/>
                                <Tab value={GRAPH_TAB_KEY} label="Graf"/>
                            </Tabs>
                        </AppBar>
                        <Box className={classes.container}>
                            { tab === TABLE_TAB_KEY && (
                                <TableScene/>
                            )}
                            { tab === GRAPH_TAB_KEY && (
                                <GraphScene/>
                            )}
                        </Box>
                    </Box>
                </MuiPickersUtilsProvider>
                </ReactQueryConfigProvider>
            </ThemeProvider>
        //</Provider>
    );
}

export default Root;
